import { CsrfTokenState } from '@johnlewispartnership/wtr-website-authentication';
import { GetOrderResponse } from 'services/orderOrchestration/types';
import { SlotType } from 'services/slotOrchestration/types';
import { TrolleyItem } from 'services/graphql/types';
import { getInstantCheckoutTrolleyItems } from 'components/InstantCheckoutModalContents/utils';

export const sendInstantCheckoutTransactionCompleteEvent = (
  trolleyItems?: TrolleyItem[],
  slotType?: SlotType,
  orderResponse?: GetOrderResponse,
  tokenServiceCsrf?: CsrfTokenState,
) => {
  const instantCheckoutTrolleyItems = getInstantCheckoutTrolleyItems(
    trolleyItems,
    orderResponse?.orderLines,
  );
  const slotBranch =
    orderResponse?.slots &&
    (orderResponse.slots.length > 1
      ? orderResponse.slots.find(({ status }) => status === 'UNCONFIRMED')
      : orderResponse.slots[0]);
  window.navigator.sendBeacon(
    '/mfe/common/api/v1/instantCheckoutTransactionComplete',
    JSON.stringify({
      customerOrderId: orderResponse?.customerOrderId,
      branchId: slotBranch?.branchId,
      deliveryChargeAmount: orderResponse?.totals.estimated.deliveryCharge.amount,
      slotType,
      instantCheckoutTrolleyItems,
      tokenServiceCsrf,
    }),
  );
};
